module.exports = __webpack_public_path__ + "static/media/logo.519e31bb.svg";